module.exports = __webpack_public_path__ + "img/icon-service-red.fe55256a.svg";